import { AfterViewInit, Directive, DoCheck, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { NbStepperComponent } from '@nebular/theme';

/**
 * Attached automatically to every `nb-stepper`.
 *
 * When the stepper header is a horizontally scrollable strip (the mobile layout), this keeps the
 * currently selected step centred in that strip: on first render, whenever the selected step
 * changes (buttons, clicks or code) and when the viewport is resized.
 * Headers that do not overflow horizontally are left untouched.
 */
@Directive({
  selector: 'nb-stepper',
})
export class StepperCenterStepDirective implements AfterViewInit, DoCheck, OnDestroy {

  private lastIndex = -1;
  private pending: any;

  constructor(private el: ElementRef, private stepper: NbStepperComponent) {
  }

  ngAfterViewInit() {
    this.schedule();
  }

  ngDoCheck() {
    if (this.stepper.selectedIndex !== this.lastIndex) {
      this.lastIndex = this.stepper.selectedIndex;
      this.schedule();
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.schedule();
  }

  ngOnDestroy() {
    clearTimeout(this.pending);
  }

  /** Waits for the DOM to reflect the new selection before measuring */
  private schedule() {
    clearTimeout(this.pending);
    this.pending = setTimeout(() => this.centerSelectedStep(), 50);
  }

  private centerSelectedStep() {
    const host: HTMLElement = this.el.nativeElement;
    const header = host.querySelector('.header') as HTMLElement;
    if (!header || header.scrollWidth <= header.clientWidth) {
      return;
    }
    const selected = header.querySelector('.step.selected') as HTMLElement;
    if (!selected) {
      return;
    }
    const left = Math.max(0, selected.offsetLeft - (header.clientWidth - selected.offsetWidth) / 2);
    if (typeof (header as any).scrollTo === 'function') {
      (header as any).scrollTo({ left, behavior: 'smooth' });
    } else {
      header.scrollLeft = left;
    }
  }
}
